import React from 'react'
import { withRouter } from "react-router-dom";
import { FormComponent } from '../../../../components/form/DynamicForm';
import { Form, Validators } from '../../../../components/form/DynamicFormTs';
import Http from '../../../../Http';

class ClienteVentas extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'cliente/administrativo', saveUrl: 'cliente/save', backUrl: '/Catalogo/Cliente/' + this.props.match.params.id + '/Administrativos' },
      new Form([
        Form.Section('Datos Fiscales'),
        Form.Field('text', 'cliente_factoraje_empresa', 'Empresa', '', [Validators.required], 6),
        Form.Field('text', 'cliente_factoraje_rfc', 'RFC', '', [Validators.required, Validators.rfc_moral], 6),
        Form.Field('select', 'cliente_factoraje_id_regimen_fiscal', 'Regimen Fiscal', '', [Validators.required], 6),
        Form.Section('Domicilio'),
        Form.Field('number', 'cliente_factoraje_cp', 'Código Postal', '', [Validators.required], 6),
        Form.Field('select', 'cliente_factoraje_id_estado', 'Estado', '', [Validators.required], 6),
        Form.Field('select', 'cliente_factoraje_id_ciudad', 'Delegación o municipio', '', [Validators.required], 6),
        Form.Field('autocomplete', 'cliente_factoraje_id_colonia', 'Colonia', '', [Validators.required], 6),
        Form.Field('text', 'cliente_factoraje_domicilio', 'Calle', '', [Validators.required], 6),
        Form.Field('text', 'cliente_factoraje_next', 'N. Ext', '', [], 6),
        
      ], ['Guardar']), this.formData
    )
    if (this.props.match.params.id) {
      this.LoadPreds(this.props.match.params.id);
    }
  }

  LoadPreds = async (predId = null, callOnChange = true) => {
    let id = predId ? predId : this.props.match.params.id;
    let Res = await Http.get(`cliente/administrativo/${id}`);
    if (!Res.error) {
      this.setState({ 
        FormData: Form.Patch(this.state.FormData, Res.data, callOnChange), 
        cliente_id_condicion_pago: Res.data.cliente_id_condicion_pago,
        id_cliente: Res.data.id
      })
    }
    return Res.data;
  }

  formData = async (form, ejecutivo = null) => {
    let newForm = form;
    const Res = await Http.get(`cliente/form-factoraje?${(this.formEstado) ? `e=${this.formEstado}&` : ''}${(this.formCp) ? `cp=${this.formCp}` : ''}`);

    if (!Res.error) {
      newForm = Form.FieldOptions(form, 'cliente_factoraje_id_estado', Res.data.estados, 'id', 'estado');
      if (Res.data.ciudades) {
        newForm = Form.FieldOptions(newForm, 'cliente_factoraje_id_ciudad', Res.data.ciudades, 'id', 'ciudad');
      }
      if (Res.data.regimenes_fiscales) {
        newForm = Form.FieldOptions(newForm, 'cliente_factoraje_id_regimen_fiscal', Res.data.regimenes_fiscales, 'id', 'label');
      }
      if (Res.data.direccion) {
        const { direccion } = Res.data;
        newForm = Form.FieldOptions(newForm, 'cliente_factoraje_id_colonia', direccion.colonias, 'id', 'colonia');
        newForm = Form.FieldOptions(newForm, 'cliente_factoraje_id_ciudad', direccion.ciudades, 'id', 'ciudad');
        newForm = Form.Patch(newForm, { cliente_factoraje_id_estado: direccion.estado.id, cliente_factoraje_id_ciudad: direccion.ciudad.id }, false);
        newForm = Form.FieldMod(newForm, 'cliente_factoraje_id_ciudad', 'Disabled', true);
        newForm = Form.FieldMod(newForm, 'cliente_factoraje_id_estado', 'Disabled', true);
      }
      newForm = Form.ValueChange(newForm, {
        cliente_factoraje_id_estado: this.estadoChange,
        cliente_factoraje_cp: this.cliCpChange,
      });
      return newForm;
    }

    return newForm;
  }

  cliCpChange = async (field) => {
    let formData = this.state.FormData;
    if (field.Value && field.Value.length === 5) {
      this.formCp = field.Value;
      this.setState({ FormData: await this.formData(formData) });
    } else {
      formData = Form.Patch(formData, { cliente_factoraje_id_colonia: '' })
      formData = Form.FieldOptions(formData, 'cliente_factoraje_id_colonia', [], 'id', 'colonia');
      this.setState({ FormData: formData }); 
    }
  }

  estadoChange = async (field) => {
    this.formEstado = field.Value;
    this.setState({ FormData: await this.formData(this.state.FormData) })
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(ClienteVentas)
